import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Route, RouteComponentProps, Switch } from "react-router";

import { ApplicationState } from "../../store";
import * as GalleryStore from "../../store/Gallery";
import GalleryGrid, { GalleryGridPurpose } from "./common/GalleryGrid";
import GallertEdit, { GalleryEditPurpose } from "./common/GalleryEdit";
import { Button, Grid } from "@material-ui/core";
import GalleryCreate, { GalleryCreatePurpose } from "./common/GalleryCreate";

interface AlbumProps extends PropsFromRedux {}

const Albums: React.FC<AlbumProps & RouteComponentProps<{ id: string }>> = (
  props
) => {
  React.useEffect(() => {
    if (!props.match.url.toLowerCase().endsWith("edit")) {
      const albumId = parseInt(props.match.params.id, 10) || 0;
      if (albumId !== 0) {
        props.getGalleryElement(albumId);
      }
      props.getGalleryElementsByParentId(albumId);
    }
  }, [props.match.params.id]);

  const galleryElements = React.useMemo(
    () => props.gallery?.galleryElementsByParentId ?? [],
    [props.gallery?.galleryElementsByParentId]
  );

  React.useEffect(() => {
    return () => {
      props.resetGalleryElement();
    };
  }, [props.resetGalleryElement]);

  return (
    <Switch>
      <Route exact path="/admin/albums">
        <>
          <Button
            variant="contained"
            size="small"
            color="primary"
            onClick={() => {
              props.history.push(`albums/create`);
            }}
          >
            Create New Album
          </Button>
          <h4 style={{ marginTop: 20, color: "#31323a" }}>Album List</h4>
          <GalleryGrid
            {...props}
            elements={galleryElements}
            purpose={GalleryGridPurpose.Albums}
          />
        </>
      </Route>
      <Route
        exact
        path={[
          "/admin/albums/:albumId/edit",
          "/admin/albums/:albumId/edit/browse",
          "/admin/albums/:albumId/edit/upload",
        ]}
        render={(routeProps) => (
          <GallertEdit purpose={GalleryEditPurpose.Album} {...routeProps} />
        )}
      />
      <Route exact path="/admin/albums/:albumId/images">
        <>
          <Grid container spacing={1}>
            <Grid item>
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={() => {
                  props.history.push(`images/create`);
                }}
              >
                Create New Image
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={() => {
                  props.history.push(`/admin/albums`);
                }}
              >
                Go to album list
              </Button>
            </Grid>
          </Grid>
          <h4
            style={{ marginTop: 20, color: "#31323a" }}
          >{`${props.gallery?.galleryElement?.elementName} album`}</h4>
          <GalleryGrid
            {...props}
            elements={galleryElements}
            purpose={GalleryGridPurpose.Images}
          />
        </>
      </Route>
      <Route
        exact
        path={[
          "/admin/albums/:albumId/images/:imageId/edit",
          "/admin/albums/:albumId/images/:imageId/edit/browse",
          "/admin/albums/:albumId/images/:imageId/edit/upload",
        ]}
        render={(routeProps) => (
          <GallertEdit purpose={GalleryEditPurpose.Image} {...routeProps} />
        )}
      />
      <Route
        exact
        path={[
          "/admin/albums/create",
          "/admin/albums/create/browse",
          "/admin/albums/create/upload",
        ]}
        render={(routeProps) => (
          <GalleryCreate purpose={GalleryCreatePurpose.Album} {...routeProps} />
        )}
      />
      <Route
        exact
        path={[
          "/admin/albums/:albumId/images/create",
          "/admin/albums/:albumId/images/create/browse",
          "/admin/albums/:albumId/images/create/upload",
        ]}
        render={(routeProps) => (
          <GalleryCreate purpose={GalleryCreatePurpose.Image} {...routeProps} />
        )}
      />
    </Switch>
  );
};

const mapStateToProps = (state: ApplicationState) => {
  return {
    gallery: state.gallery,
  };
};

const mapDispatch = {
  getGalleryElementsByParentId: (parentId: number) =>
    GalleryStore.actionCreators.requestGalleryElementsByParentId(parentId),
  getGalleryElement: (elementId: number) =>
    GalleryStore.actionCreators.getGalleryElement(elementId),
  resetGalleryElement: GalleryStore.actionCreators.resetGalleryElement,
};

const connector = connect(mapStateToProps, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connect(mapStateToProps, mapDispatch)(Albums as any);
//export default Albums;
